import React, { Component, Fragment } from 'react';
import FormInputText from '../../../_shared/forms/FormInputText';
import FormCheckbox from '../../../_shared/forms/FormCheckbox';
import DatePicker from 'react-datepicker';
import FormError from '../../../_shared/forms/FormError';
import { SearchableSelect } from '../../../_shared/forms/FormMultiSelect';
import FormInputNumber from '../../../_shared/forms/FormInputNumber';

class JobDetails extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <div className="row pb-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Job Details</h6>
                    </div>
                </div>

                <div className="row">
                    <div className="form-group col-md-4">
                        <FormInputText
                            type="text"
                            name="address"
                            label="Address line 1"
                            value={this.props.address}
                            classes={this.props.errors.address ? 'form-control is-invalid' : 'form-control'}
                            error={this.props.errors.address}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <FormInputText
                            type="text"
                            name="postcode"
                            label="postcode"
                            value={this.props.postcode}
                            classes={this.props.errors.postcode ? 'form-control is-invalid' : 'form-control'}
                            error={this.props.errors.postcode}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <SearchableSelect
                            name="tip_offs"
                            options={this.props.tipOffOptions}
                            value={this.props.tipOff}
                            handleChange={this.props.handleSearchableSelectChange}
                            error={this.props.errors.tipOff}
                            label="Select tip off"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4">
                        <label>Collection date and time</label>
                        <DatePicker
                            className={this.props.errors.collection_date ? 'form-control is-invalid' : 'form-control'}
                            placeholderText="collection date"
                            selected={this.props.collection_date || null}
                            onChange={(date) => this.props.handleDateChange(date, 'collection_date')}
                            dateFormat="dd/MM/yyyy HH:mm"
                            timeFormat="HH:mm"
                            timeInterval={15}
                            showTimeSelect
                        />
                        <FormError error={this.props.errors.collection_date} />
                    </div>
                    <div className="form-group col-md-4">
                        <label>Completion date and time</label>
                        <DatePicker
                            className={this.props.errors.completion_time ? 'form-control is-invalid' : 'form-control'}
                            placeholderText="completion time"
                            selected={this.props.completion_time || null}
                            onChange={(date) => this.props.handleDateChange(date, 'completion_time')}
                            dateFormat="dd/MM/yyyy HH:mm"
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            showTimeSelect
                        />
                        <FormError error={this.props.errors.completion_time} />
                    </div>
                </div>
                <div className="row hidden">
                    <div className="form-group col-md-4">
                        <FormInputNumber
                            type="number"
                            label="Quantity"
                            name="quantity"
                            ste="1"
                            min="0"
                            classes="form-control"
                            value={this.props.quantity}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <FormInputNumber
                            type="number"
                            label="Provider quantity"
                            name="provider_quantity"
                            step="1"
                            min="0"
                            classes="form-control"
                            value={this.props.provider_quantity}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                </div>
                {this.props.manager_review === 'yes' ? (
                    <div className="row">
                        <div className="col-12">
                            <FormInputText
                                label="Manager Review Reason"
                                name="manager_review_reason"
                                type="text"
                                classes={
                                    this.props.errors.manager_review_reason ? 'form-control is-invalid' : 'form-control'
                                }
                                value={this.props.manager_review_reason}
                                handleChange={this.props.handleChange}
                                error={this.props.errors.manager_review_reason}
                            />
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {this.props.manager_review_flag_reason ? (
                    <div className="row">
                        <div className="col-12">
                            <p>Manager Review Flagged by: {this.props.manager_review_flag_reason}</p>
                        </div>
                    </div>
                ) : (
                    ''
                )}
                <div className="row">
                    <div className="col-12">
                        <FormCheckbox
                            name="manager_review"
                            label="MANAGER REVIEW"
                            checked={this.props.manager_review === 'yes'}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default JobDetails;
